(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["voowin-footer"]) return;
  try {
    
function initVoowinFooter(){document.querySelectorAll('.vp-footer-group').forEach(group=>{group.open=matchMedia('(min-width: 741px)').matches;});}initVoowinFooter();document.addEventListener('shopify:section:load',initVoowinFooter);matchMedia('(min-width: 741px)').addEventListener('change',initVoowinFooter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voowin-header"]) return;
  try {
    
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.vp-header details[open]').forEach(item=>item.open=false)});
document.addEventListener('click',event=>{if(!event.target.closest('.vp-header'))document.querySelectorAll('.vp-header details[open]').forEach(item=>item.open=false);if(event.target.closest('.vp-mobile-links a'))document.querySelectorAll('.vp-header details[open]').forEach(item=>item.open=false)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vw-premium-campaign"] && !Shopify.designMode) return;
  try {
    
function refreshVoowinCampaigns(){document.querySelectorAll('[data-vp-campaign]').forEach(root=>{const promo=root.querySelector('[data-vp-promo]');if(!promo||promo.dataset.phase!=='active')return;const end=Date.parse(promo.dataset.end);if(Number.isFinite(end)&&Date.now()>=end){promo.hidden=true;root.querySelector('[data-vp-institutional]').hidden=false;}})}
refreshVoowinCampaigns();setInterval(refreshVoowinCampaigns,60000);document.addEventListener('shopify:section:load',refreshVoowinCampaigns);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vw-premium-stores"] && !Shopify.designMode) return;
  try {
    
function initializeVoowinStores(){document.querySelectorAll('[data-vp-stores]').forEach(root=>{const select=root.querySelector('[data-vp-city]');if(!select||select.dataset.bound)return;select.dataset.bound='true';select.addEventListener('change',()=>{root.querySelectorAll('[data-city]').forEach(card=>{card.hidden=Boolean(select.value&&card.dataset.city!==select.value)});root.querySelector('.vp-store-rail').scrollLeft=0;});});}initializeVoowinStores();document.addEventListener('shopify:section:load',initializeVoowinStores);

  } catch(e) { console.error(e); }
})();
})();
